import Modal from "../ui-components/Modal";
import Button from "../ui-components/Button";
import {FormattedMessage, useIntl} from "react-intl";
import {PencilIcon, PlusIcon, ChevronUpIcon, ChevronDownIcon} from "@heroicons/react/24/outline";
import Checkbox from "../ui-components/Checkbox";
import {useState} from "react";
import ServiceConfiguratorBlockExpressionConfigurator from "./ServiceConfiguratorBlockExpressionConfigurator";
import CloseIcon from "./CloseIcon";
import {ExclamationTriangleIcon} from "@heroicons/react/24/outline";
import Tooltip from "../ui-components/Tooltip";

export const KColorProductsDependenciesEditor = (
  {
    onExit,
    onConfirm,
    newData,
    setNewData,
    KColorProducts,
    setShowDependencies,
    block,
    questions,
    recursiveQuestions,
    outputs,
    data,
    type,
    service,
    ...rest
  }
) => {

  const intl = useIntl();
  const [productChosenTobeEdited, setProductChosenTobeEdited] = useState(null);
  const [packageChosenTobeEdited, setPackageChosenTobeEdited] = useState(null);
  const [showProductsPackages, setShowProductsPackages] = useState({});

  const getProductCheckedStatus = (cod_prod_comm) => {
    if (!newData || !newData[cod_prod_comm]) {
      return false;
    }
    return !newData[cod_prod_comm].disabled;
  }

  const getPackageCheckedStatus = (cod_prod_comm, packageQty) => {
    if (!newData || !newData[cod_prod_comm] || !newData[cod_prod_comm][packageQty]) {
      return false;
    }
    return !newData[cod_prod_comm][packageQty].disabled;
  }

  const getGlobalCheckedStatus = () => {
    if (!newData) {
      return false;
    }
    for (const v of KColorProducts) {
      if (!newData[v.cod_prod_comm] || newData[v.cod_prod_comm].disabled) {
        return false;
      }
    }
    return true;
  }

  return(
    <div className={`animate-slideIn w-1/2 lg:w-1/3 fixed inset-y-0 right-0 bg-white overflow-y-auto pl-4 pr-4 pt-2 shadow-2xl pb-6 right-1/2 lg:right-1/3`}>
      <CloseIcon
        text={""}
        onClick={() => {
          onExit();
        }}
      />
      <>
      {(productChosenTobeEdited || packageChosenTobeEdited ?
        <div className={"p-4 flex flex-col gap-4"}>

          {productChosenTobeEdited &&
            <div className={"flex flex-row items-center justify-start gap-4"}>
              <span className={"font-bold"}>{productChosenTobeEdited.cod_prod_comm}</span>
              <span>{productChosenTobeEdited.des_prod_comm}</span>
            </div>
          }
          {packageChosenTobeEdited &&
            <div className={"flex flex-row items-center justify-start gap-4"}>
              <span className={'font-bold'}>{packageChosenTobeEdited.product.cod_prod_comm}</span>
              <span>{packageChosenTobeEdited.product.des_prod_comm}</span>
              <span>{` - package ${packageChosenTobeEdited.package} ${packageChosenTobeEdited.product.base_um}`}</span>
            </div>}


          <ServiceConfiguratorBlockExpressionConfigurator
            setShowDependencies={(val)=>{
              setProductChosenTobeEdited(null)
              setPackageChosenTobeEdited(null)
              setShowDependencies(val)
            }}
            fullExpression={packageChosenTobeEdited ?
              newData[packageChosenTobeEdited.product.cod_prod_comm]?.[packageChosenTobeEdited.package]?.['dependencies'] || []:
              newData?.[productChosenTobeEdited.cod_prod_comm]?.['dependencies'] || []
            }
            newData={packageChosenTobeEdited ?
              newData?.[packageChosenTobeEdited.product.cod_prod_comm]?.[packageChosenTobeEdited.package] || {'dependencies': []} :
              newData?.[productChosenTobeEdited.cod_prod_comm] || {'dependencies': []}
            }
            setNewData={(v) => {
              const nd = {...newData};
              if (packageChosenTobeEdited) {
                // It's a package
                if (!nd[packageChosenTobeEdited.product.cod_prod_comm]) {
                  // No product entry yet
                  nd[packageChosenTobeEdited.product.cod_prod_comm] = {
                    disabled: false,
                    dependencies: [],
                    [packageChosenTobeEdited.package]: {
                      disabled: false,
                      dependencies: v.dependencies,
                    }
                  }
                } else if (!nd[packageChosenTobeEdited.product.cod_prod_comm][packageChosenTobeEdited.package]) {
                  // No package entry yet (inside an existing product entry)
                  nd[packageChosenTobeEdited.product.cod_prod_comm][packageChosenTobeEdited.package] = {
                    disabled: false,
                    dependencies: v.dependencies,
                  }
                } else {
                  // Just update the package entry
                  nd[packageChosenTobeEdited.product.cod_prod_comm][packageChosenTobeEdited.package].dependencies = v.dependencies;
                }
              } else {
                // It's a product
                if (!nd[productChosenTobeEdited.cod_prod_comm]) {
                  // No product entry yet
                  nd[productChosenTobeEdited.cod_prod_comm] = {
                    disabled: false,
                    dependencies: v.dependencies,
                  }
                } else {
                  // Just update the product entry dependencies
                  nd[productChosenTobeEdited.cod_prod_comm].dependencies = v.dependencies;
                }
              }
              setNewData(nd);
            }}
            block={block}
            questions={questions}
            recursiveQuestions={recursiveQuestions}
            outputs={outputs}
            data={data}
            type={type}
            service={service}
            editable={true}
            {...rest}
          />
        </div> :
        <div>
          <div className={'p-4 overflow-y-auto flex flex-col gap-4'}>
            <span>
              {intl.formatMessage({
                id: "kcolor_products_dependencies_editor",
                defaultMessage: "K-Color products dependencies editor"
              })}
            </span>
            <div className="flex flex-row gap-2 items-center italic">
              <Checkbox
                checked={getGlobalCheckedStatus()}
                onChange={(e) => {
                  const nd = {...newData};
                  KColorProducts.forEach(v => {
                    if (!nd[v.cod_prod_comm]) {
                      nd[v.cod_prod_comm] = {
                        disabled: !e.target.checked,
                        dependencies: []
                      }
                    } else {
                      nd[v.cod_prod_comm].disabled = !e.target.checked;
                    }
                    const qties = KColorProducts.find(p => p.cod_prod_comm === v.cod_prod_comm)?.lst_min_qty || [];
                    for (const productPackgage of qties) {
                      if (!nd[v.cod_prod_comm][productPackgage]) {
                        nd[v.cod_prod_comm][productPackgage] = {
                          disabled: !e.target.checked,
                          dependencies: []
                        }
                      } else {
                        nd[v.cod_prod_comm][productPackgage].disabled = !e.target.checked;
                      }
                    }
                  })
                  setNewData(nd);
                }}
              />
              <span className="leading-none">
                <FormattedMessage id="select_deselect_all" defaultMessage="Seleziona/Deseleziona tutto"/>
              </span>
            </div>
            <div>
              {KColorProducts.map(v => {
                // PRODUCT ROW
                return <div key={v.id} className="border p-2 my-2 flex flex-col gap-2">
                  <div className={"flex flex-row justify-between gap-4"}>
                    <div className={"flex flex-row gap-2 items-center"}>
                      <Checkbox
                        checked={getProductCheckedStatus(v.cod_prod_comm)}
                        onChange={(e) => {
                          const nd = {...newData};
                          if (!nd[v.cod_prod_comm]) {
                            nd[v.cod_prod_comm] = {
                              disabled: !e.target.checked,
                              dependencies: []
                            }
                          } else {
                            nd[v.cod_prod_comm].disabled = !e.target.checked;
                          }
                          setNewData(nd);
                        }}
                      />
                      <div className={"flex flex-row gap-2 items-center"}>
                        <div className={`${v.active?'':'text-gray-500'} flex flex-row gap-1 items-center`}>
                          <span className="font-semibold">{v.cod_prod_comm}</span>
                          {" "}&ndash;{" "}
                          {v.des_prod_comm}
                          {v.active? null: <div className={"flex flex-row items-center"}> (
                            <span>{intl.formatMessage({id: "inactive", defaultMessage: "Inactive"})}</span>
                            <div className={"mt-1"}>
                              <Tooltip
                                text={intl.formatMessage({
                                  id: "product_inactive_tooltip",
                                  defaultMessage: "This product is currently inactive, which means either we are not receiving it anymore among the K-Color products, or that we are receiving it but with inactive status."
                                })}
                                placement="bottom-end"
                                iconName={"XCircleIcon"}
                                styleType="white"
                                className="w-4 h-4"
                              />
                            </div>
                            )
                          </div>
                          }
                        </div>

                        {!v.is_in_pricebook && <div className={"mt-0.5"}>
                          <Tooltip
                            text={intl.formatMessage({
                              id: "no_products_in_pricebook_tooltip",
                              defaultMessage: "This product is not present in the pricebook! the packages you see may not reflect the actual available packages which must be in the pricebook."
                            })}
                            placement="bottom-end"
                            iconName={"ExclamationTriangleIcon"}
                            styleType="white"
                            className="w-4 h-4 text-yellow-500"
                          />
                        </div>}
                      </div>
                      <div className="mt-0.5">
                        {
                          showProductsPackages[v.cod_prod_comm] ?
                            <ChevronUpIcon className="w-4 h-4 cursor-pointer" onClick={() => {
                              setShowProductsPackages({
                                ...showProductsPackages,
                                [v.cod_prod_comm]: false
                              })
                            }}/>
                            : <ChevronDownIcon className="w-4 h-4 cursor-pointer" onClick={() => {
                              setShowProductsPackages({
                                ...showProductsPackages,
                                [v.cod_prod_comm]: true
                              })
                            }}
                            />
                        }
                      </div>
                    </div>
                    <div className={"flex flex-row gap-2 items-center"}>
                      <span className="leading-none">Dependencies</span>
                      {
                        newData?.[v.cod_prod_comm]?.dependencies?.length > 0 ?
                          <PencilIcon className="w-4 h-4 cursor-pointer" onClick={() => {
                            setProductChosenTobeEdited(v)
                          }}/>
                          : <PlusIcon className="w-4 h-4 cursor-pointer" onClick={() => {
                            setProductChosenTobeEdited(v)
                          }}/>
                      }
                    </div>
                  </div>

                  {/*PACKAGES*/}
                  {showProductsPackages[v.cod_prod_comm] && <div className={"flex flex-col gap-1"}>
                    {
                      v?.lst_min_qty?.map((qtyNmbr, idx) => (
                        //  PACKAGE ROW
                        <div key={idx} className="text-sm flex flex-row items-center justify-between gap-2">
                          <div className={"flex flex-row gap-2 items-center"}>
                            <Checkbox
                              // disabled={!getProductCheckedStatus(v.cod_prod_comm)}
                              checked={getPackageCheckedStatus(v.cod_prod_comm, qtyNmbr)}
                              onChange={(e) => {
                                const nd = {...newData}
                                if (!nd[v.cod_prod_comm]) {
                                  nd[v.cod_prod_comm] = {
                                    disabled: false,
                                    dependencies: [],
                                    [qtyNmbr]: {
                                      disabled: !e.target.checked,
                                      dependencies: [],
                                    }
                                  }
                                } else if (!nd[v.cod_prod_comm][qtyNmbr]) {
                                  nd[v.cod_prod_comm][qtyNmbr] = {
                                    disabled: !e.target.checked,
                                    dependencies: [],
                                  }
                                } else {
                                  nd[v.cod_prod_comm][qtyNmbr].disabled = !e.target.checked;
                                }
                                setNewData(nd);
                              }}
                            />
                            <span className={!newData[v.cod_prod_comm]?.disabled ? '':'line-through'}>
                              Package {qtyNmbr} {v.base_um}
                            </span>
                          </div>
                          <div className={"flex flex-row gap-2 items-center"}>
                            <span>Dependencies</span>
                            {
                              newData?.[v.cod_prod_comm]?.[qtyNmbr]?.dependencies?.length > 0 ?
                                <PencilIcon className="w-4 h-4 cursor-pointer" onClick={() => {
                                  setPackageChosenTobeEdited({product: v, package: qtyNmbr})
                                }}/>
                                : <PlusIcon className="w-4 h-4 cursor-pointer" onClick={() => {
                                  setPackageChosenTobeEdited({product: v, package: qtyNmbr})
                                }}/>
                            }
                          </div>
                        </div>
                        // END PACKAGE ROW
                      ))
                    }
                  </div>}
                </div>
              })}
            </div>
          </div>
          <div className="mt-4 flex justify-center">
            <Button
              onClick={() => {
                onExit();
              }}
              styleType="primary"
              className="ml-2"
            >
              {intl.formatMessage({id: "confirm"})}
            </Button>
          </div>
        </div>)}
    </>
  </div>);
}